/**
 * EventTracking ("מעקב אירועים") — route /eventTracking. Website analytics from visitor_events
 * (what talroman.com sends to POST /api/wix/track — see claudeDocs/WEBSITE_TRACKING_EVENTS.md).
 *
 * Tabs:
 *   דאשבורד       components/Dashboard.js — funnels, visitor trend, scroll / page engagement,
 *                 Google search keywords, referrers, live activity, for a date range.
 *   הגדרת משפכים  components/FunnelStageManager.js — funnels and their stages (event-type prefixes).
 *
 * This file only wires the (unchanged) Redux actions into the two tabs.
 */
import React, { useState } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actionsCreators from '../../actions/index.js';
import { Page, PageHeader, Tabs } from '../../ui';

import Dashboard from './components/Dashboard';
import FunnelStageManager from './components/FunnelStageManager';

const EventTracking = (props) => {
  const [activeTab, setActiveTab] = useState('dashboard');

  return (
    <Page>
      <PageHeader title="מעקב אירועים" subtitle="מה מבקרים עושים באתר ואיפה הם נושרים במשפך" />
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        items={[
          {
            key: 'dashboard',
            label: 'דאשבורד',
            children: (
              <Dashboard
                getAllFunnelsStats={props.getAllFunnelsStats}
                getFunnelStats={props.getFunnelStats}
                getRealTimeStats={props.getRealTimeStats}
                getVisitorTrends={props.getVisitorTrends}
                getEngagementStats={props.getEngagementStats}
                getSearchKeywords={props.getSearchKeywords}
                getReferrerStats={props.getReferrerStats}
                showAlert={props.showAlert}
              />
            ),
          },
          {
            key: 'stages',
            label: 'הגדרת משפכים',
            children: (
              <FunnelStageManager
                getAllFunnels={props.getAllFunnels}
                getFunnelById={props.getFunnelById}
                createFunnel={props.createFunnel}
                updateFunnel={props.updateFunnel}
                deleteFunnel={props.deleteFunnel}
                reorderFunnels={props.reorderFunnels}
                seedDefaultFunnel={props.seedDefaultFunnel}
                getFunnelStages={props.getFunnelStages}
                createFunnelStage={props.createFunnelStage}
                updateFunnelStage={props.updateFunnelStage}
                deleteFunnelStage={props.deleteFunnelStage}
                reorderFunnelStages={props.reorderFunnelStages}
                showAlert={props.showAlert}
              />
            ),
          },
        ]}
      />
    </Page>
  );
};

const mapStateToProps = () => ({});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      // Funnel CRUD
      getAllFunnels: actionsCreators.getAllFunnels,
      getFunnelById: actionsCreators.getFunnelById,
      createFunnel: actionsCreators.createFunnel,
      updateFunnel: actionsCreators.updateFunnel,
      deleteFunnel: actionsCreators.deleteFunnel,
      reorderFunnels: actionsCreators.reorderFunnels,
      seedDefaultFunnel: actionsCreators.seedDefaultFunnel,
      // Funnel Analytics
      getAllFunnelsStats: actionsCreators.getAllFunnelsStats,
      getFunnelStats: actionsCreators.getFunnelStats,
      getRealTimeStats: actionsCreators.getRealTimeStats,
      getVisitorTrends: actionsCreators.getVisitorTrends,
      getEngagementStats: actionsCreators.getEngagementStats,
      getSearchKeywords: actionsCreators.getSearchKeywords,
      getReferrerStats: actionsCreators.getReferrerStats,
      // Stage CRUD
      getFunnelStages: actionsCreators.getFunnelStages,
      createFunnelStage: actionsCreators.createFunnelStage,
      updateFunnelStage: actionsCreators.updateFunnelStage,
      deleteFunnelStage: actionsCreators.deleteFunnelStage,
      reorderFunnelStages: actionsCreators.reorderFunnelStages,
      // General
      showAlert: actionsCreators.showAlert,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(EventTracking);
